// extracted by mini-css-extract-plugin
module.exports =  {"container":"KSCxzXfVVqd2GeyTQgnc","containerWide":"zK1s8R2dfBY2O3pnQkoU"};